import type { CAdvertisementsTranslations } from "./pl";

export const en: CAdvertisementsTranslations = {
  emptyData: "No data to display.",

  /* Search */
  searchTitle: "Search",
  searchBtn: "Search",
  allTypes: "All types",
  fields: {
    keyword: "Phrase",
    type: "Type",
    priceFrom: "Price from",
    priceTo: "Price to",
  },

  /* Validation */
  validation: {
    invalidPrice: "Invalid price value (max 2 decimal places).",
  },

  /* Categories */
  categoriesTitle: "Categories",
  noCategories: "No categories.",
  adsCount: (n) => (n === 1 ? "1 ad" : `${n} ads`),

  /* Search results */
  resultsTitle: (n) =>
    n === 1 ? "Found 1 ad" : `Found ${n} ads`,
  noAdsFound: "No ads matching the given criteria were found.",
  addDate: "Added",
  price: "Price",
  negotiatedPrice: "Price negotiable",
  priceNotSet: "-",
  formatPrice: (value) => {
    try {
      return new Intl.NumberFormat("en-GB", {
        style: "currency",
        currency: "PLN",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value);
    } catch {
      return `${value.toFixed(2)} PLN`;
    }
  },
  readMore: "Read more ->",
};
